__turbopack_context__.v({
  "buttonGrid": "ChoiceButtonLayout-module__QW4Dga__buttonGrid",
  "choiceButton": "ChoiceButtonLayout-module__QW4Dga__choiceButton",
  "ratingButton": "ChoiceButtonLayout-module__QW4Dga__ratingButton",
  "ratingButtonGrid": "ChoiceButtonLayout-module__QW4Dga__ratingButtonGrid",
  "singleSelectButton": "ChoiceButtonLayout-module__QW4Dga__singleSelectButton",
  "singleSelectButtonGrid": "ChoiceButtonLayout-module__QW4Dga__singleSelectButtonGrid",
});
